import { FuelButton, FuelInteractiveIcon, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelModal } from '@frete.com/fuel-station-react';
import { FC, useMemo } from 'react';

import { PORTAL } from '@/constants';

import {
  ChildrenContainer,
  CloseContainer,
  Container,
  Footer,
  InvisibleSpace,
  Step,
  Steps,
  TitleContainer,
} from './styled';
import { LearnMoreModalProps } from './types';

export const LearnMoreModal: FC<LearnMoreModalProps> = ({
  isOpen,
  children,
  icon,
  title,
  subtitle,
  disabledPrevious,
  nextText,
  totalSteps,
  currentStep,
  onClose,
  onNext,
  onOpen,
  onPrevious,
}) => {
  const steps = useMemo(() => Array.from({ length: totalSteps }, (_, i) => i), [totalSteps]);

  return (
    <FuelModal
      isOpen={isOpen}
      onClose={onClose}
      width="lg"
      removePortalOnDestroy={false}
      portalName={`.${PORTAL}`}
      data-testid="learn-more-modal"
    >
      <Container>
        <CloseContainer>
          <FuelInteractiveIcon onClick={onClose} size="medium" icon="close" />
        </CloseContainer>
        <FuelSign icon={icon} size="small" iconStyle="filled" />
        <TitleContainer>
          <FuelTypography size="body-lg" weight="bold" color="neutral-strong">
            {title}
          </FuelTypography>
          {subtitle && (
            <FuelTypography size="body-md" weight="regular" color="neutral-default">
              {subtitle}
            </FuelTypography>
          )}
        </TitleContainer>
        <ChildrenContainer>{children}</ChildrenContainer>
        <Footer>
          {disabledPrevious ? (
            <InvisibleSpace />
          ) : (
            <FuelButton size="large" variant="tertiary" onClick={onPrevious}>
              Anterior
            </FuelButton>
          )}
          <Steps data-testid="steps-list">
            {steps.map((index) => (
              <Step $active={currentStep === index} key={index} onClick={() => onOpen(index)} />
            ))}
          </Steps>
          <FuelButton size="large" variant="tertiary" onClick={onNext}>
            {nextText}
          </FuelButton>
        </Footer>
      </Container>
    </FuelModal>
  );
};
